(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["larflaser-cart-previews"] && !Shopify.designMode) return;
  try {
    (function() {
  'use strict';
  if (window.LarflaserCartPreview && window.LarflaserCartPreview.__v16) return;
  var DB_NAME = 'Larflaser-anteprime-carrello';
  var DB_STORE = 'thumbs';
  var FALLBACK_PREFIX = 'larflaser-cart-thumb-fallback:';
  var LIFETIME = 7 * 24 * 60 * 60 * 1000;
  var memory = new Map();
  var revision = 0;
  var dbPromise = null;
  var scheduled = 0;
  var running = false;

  function validId(id) { return typeof id === 'string' && /^[a-zA-Z0-9_-]{6,150}$/.test(id); }
  function goodEntry(entry) {
    return entry && Number(entry.expires) > Date.now() &&
      typeof entry.src === 'string' && /^data:image\/(?:jpeg|png);base64,/.test(entry.src);
  }
  function openDB() {
    if (dbPromise) return dbPromise;
    dbPromise = new Promise(function(resolve) {
      if (!window.indexedDB) { resolve(null); return; }
      var request;
      try { request = indexedDB.open(DB_NAME, 1); } catch(e) { resolve(null); return; }
      request.onupgradeneeded = function() {
        if (!request.result.objectStoreNames.contains(DB_STORE))
          request.result.createObjectStore(DB_STORE, {keyPath:'id'});
      };
      request.onsuccess = function() { resolve(request.result); };
      request.onerror = function() { resolve(null); };
      request.onblocked = function() { resolve(null); };
    });
    return dbPromise;
  }
  function transactionPromise(operation, mode) {
    return openDB().then(function(db) {
      if (!db) return null;
      return new Promise(function(resolve) {
        var transaction, request, settled = false;
        function done(value) { if (!settled) { settled = true; resolve(value); } }
        try {
          transaction = db.transaction(DB_STORE, mode || 'readonly');
          request = operation(transaction.objectStore(DB_STORE));
          if (mode === 'readwrite') {
            // Le scritture si considerano riuscite soltanto alla commit.
            transaction.oncomplete = function() { done(true); };
          } else {
            request.onsuccess = function() { done(request.result === undefined ? true : request.result); };
          }
          request.onerror = function() { done(null); };
          transaction.onerror = function() { done(null); };
          transaction.onabort = function() { done(null); };
        } catch(e) { done(null); }
      });
    });
  }
  function saveFallback(id, entry) {
    try { sessionStorage.setItem(FALLBACK_PREFIX + id, JSON.stringify(entry)); } catch(e) { /* storage unavailable */ }
  }
  function readFallback(id) {
    try { return JSON.parse(sessionStorage.getItem(FALLBACK_PREFIX + id) || 'null'); }
    catch(e) { return null; }
  }
  function removeFallback(id) {
    try { sessionStorage.removeItem(FALLBACK_PREFIX + id); } catch(e) {}
  }
  async function read(id) {
    if (!validId(id)) return null;
    var entry = memory.get(id);
    if (!entry) {
      entry = await transactionPromise(function(store) { return store.get(id); });
      if (!entry) entry = readFallback(id);
      if (goodEntry(entry)) memory.set(id, entry);
    }
    if (goodEntry(entry)) return entry;
    if (entry) void forget(id);
    return null;
  }
  async function forget(id) {
    if (!validId(id)) return;
    memory.delete(id);
    removeFallback(id);
    await transactionPromise(function(store) { return store.delete(id); }, 'readwrite');
    revision++; schedule();
  }
  function toThumbnail(file, kind) {
    return new Promise(function(resolve, reject) {
      var src = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function() {
        try {
          var side = kind === 'qr' ? 900 : 720;
          var scale = Math.min(1, side / Math.max(img.naturalWidth, img.naturalHeight));
          var canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(img.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(img.naturalHeight * scale));
          var ctx = canvas.getContext('2d');
          if (!ctx) throw new Error('Canvas non disponibile');
          ctx.fillStyle='#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          var data = kind === 'qr' ? canvas.toDataURL('image/png') : canvas.toDataURL('image/jpeg', .8);
          URL.revokeObjectURL(src); resolve(data);
        } catch(e) { URL.revokeObjectURL(src); reject(e); }
      };
      img.onerror = function() { URL.revokeObjectURL(src); reject(new Error('Anteprima non leggibile')); };
      img.src = src;
    });
  }
  async function store(id, file, kind) {
    if (!validId(id) || !file) return;
    var actualKind = kind === 'qr' ? 'qr' : 'photo';
    var src = await toThumbnail(file, actualKind);
    var entry = {
      id:id, src:src, kind:actualKind,
      name:String(file.name || '').slice(0,130), expires:Date.now() + LIFETIME
    };
    memory.set(id,entry);
    var result = await transactionPromise(function(dbStore) { return dbStore.put(entry); }, 'readwrite');
    if (result === null) saveFallback(id,entry);
    revision++; schedule();
  }
  function cleanupExpired() {
    // Cancellazione al caricamento della pagina: evitiamo nuovi servizi esterni.
    void openDB().then(function(db) {
      if (!db) return;
      try {
        var tr = db.transaction(DB_STORE,'readwrite');
        tr.objectStore(DB_STORE).openCursor().onsuccess = function(e) {
          var cursor = e.target.result;
          if (!cursor) return;
          if (!goodEntry(cursor.value)) cursor.delete();
          cursor.continue();
        };
      } catch(e) {}
    });
    try {
      for (var i=sessionStorage.length-1; i>=0; i--) {
        var k=sessionStorage.key(i);
        if (k && k.indexOf(FALLBACK_PREFIX)===0 && !goodEntry(JSON.parse(sessionStorage.getItem(k) || 'null')))
          sessionStorage.removeItem(k);
      }
    } catch(e) {}
  }
  window.LarflaserCartPreview = {__v16:true,store:store,get:read,forget:forget};
  cleanupExpired();

  var modal=document.getElementById('larf-cart-files-zoom');
  if (!modal) {
    modal=document.createElement('dialog');
    modal.id='larf-cart-files-zoom';
    modal.setAttribute('aria-label','Anteprima ingrandita immagini del carrello');
    modal.innerHTML='<div class="larf-cart-files-modal__inner"><button type="button" class="larf-cart-files-modal__close" aria-label="Chiudi anteprima">×</button><img class="larf-cart-files-modal__img" alt="Immagine ingrandita" width="900" height="900"><p class="larf-cart-files-modal__caption"></p></div>';
    document.body.appendChild(modal);
  }
  var modalImage=modal.querySelector('.larf-cart-files-modal__img');
  var modalCaption=modal.querySelector('.larf-cart-files-modal__caption');
  var openButton=null;
  var priorOverflow='';
  function closeModal() { if (modal.open) modal.close(); }
  modal.querySelector('.larf-cart-files-modal__close').addEventListener('click',closeModal);
  modal.addEventListener('click',function(e) { if(e.target === modal) closeModal(); });
  modal.addEventListener('close',function() {
    modalImage.removeAttribute('src');
    document.body.style.overflow=priorOverflow;
    if (openButton && openButton.isConnected) {
      try { openButton.focus({preventScroll:true}); } catch(e) { openButton.focus(); }
    }
    openButton=null;
  });
  function openModal(src,label,trigger,kind) {
    if (!modal.showModal) return;
    modal.style.setProperty('--larf-modal-accent',kind === 'qr' ? '#FFD400' : '#70BF54');
    openButton=trigger;
    modalImage.src=src;
    modalImage.alt=label + ' ingrandito';
    modalCaption.textContent=label+' · premi X per chiudere';
    priorOverflow=document.body.style.overflow;
    modal.showModal();
    document.body.style.overflow='hidden';
    modal.querySelector('.larf-cart-files-modal__close').focus({preventScroll:true});
  }
  function getCartURL(name) {
    var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    return root + 'cart' + (name ? '/'+name : '') + '.js';
  }
  function generateDraftId() {
    var bytes=new Uint8Array(8);
    if (!window.crypto || !window.crypto.getRandomValues) throw new Error('Browser non compatibile con il caricamento sicuro.');
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes,function(value){return value.toString(16).padStart(2,'0');}).join('');
  }
  async function loadTurnstile() {
    if (window.turnstile && typeof window.turnstile.render === 'function') return window.turnstile;
    if (!window.__larflaserR2TurnstilePromise) {
      window.__larflaserR2TurnstilePromise = new Promise(function(resolve,reject) {
        var el=document.createElement('script');
        el.src='https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        el.async=true;
        el.onload=function(){window.turnstile?resolve(window.turnstile):reject(new Error('Verifica di sicurezza non disponibile.'));};
        el.onerror=function(){reject(new Error('Impossibile caricare la verifica di sicurezza.'));};
        document.head.appendChild(el);
      });
    }
    return window.__larflaserR2TurnstilePromise;
  }
  async function getTurnstileToken(row) {
    var ts=await loadTurnstile();
    var host=document.createElement('div'); host.className='larf-cart-files__turnstile';
    row.appendChild(host);
    return new Promise(function(resolve,reject) {
      var widget=null,done=false;
      function finish(error,token){
        if(done)return;done=true;
        if(widget!==null&&typeof ts.remove==='function')try{ts.remove(widget);}catch(e){}
        host.remove();
        if(error)reject(error);else resolve(token);
      }
      try {
        widget=ts.render(host,{
          sitekey:'0x4AAAAAAFye1Ly1QswBPOmm',
          action:'larflaser_upload',appearance:'interaction-only',execution:'execute',
          callback:function(token){finish(null,token);},
          'error-callback':function(){finish(new Error('Verifica di sicurezza non riuscita. Riprova.'));},
          'expired-callback':function(){finish(new Error('Verifica scaduta. Riprova.'));}
        });
        ts.execute(widget);
      }catch(error){finish(error);}
    });
  }
  function freshLineItem(cart,oldKey,kind,oldId) {
    var propKey=kind==='qr'?'_Larflaser QR ID':'_Larflaser Photo ID';
    var pos=cart.items.findIndex(function(item){return String(item.key)===oldKey;});
    if(pos<0)throw new Error('Il carrello è cambiato: riaprilo e riprova.');
    var item=cart.items[pos];
    if(String(item.properties?.[propKey]||'')!==oldId)throw new Error('Questa immagine è già stata modificata. Aggiorna il carrello.');
    return {item:item,index:pos,propKey:propKey};
  }
  async function cartJSON() {
    var response=await fetch(getCartURL(''), {credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw new Error('Impossibile leggere il carrello.');
    return response.json();
  }
  async function changeImageInCart(file,kind,oldId,oldKey,row,changeButton,status) {
    if(!file)return;
    if(!['image/jpeg','image/png','image/webp'].includes(file.type)) {
      status.textContent='Scegli un file JPG, PNG o WEBP.';status.dataset.error='true';return;
    }
    if(file.size<=0||file.size>10*1024*1024) {
      status.textContent='Il file deve essere inferiore a 10 MB.';status.dataset.error='true';return;
    }
    changeButton.disabled=true;
    var propKey=kind==='qr'?'_Larflaser QR ID':'_Larflaser Photo ID';
    try {
      status.textContent='Preparazione del nuovo caricamento…';status.dataset.error='false';
      var initial=await cartJSON();
      var found=freshLineItem(initial,oldKey,kind,oldId);
      var draftId=String(found.item.properties?.['_Larflaser Draft ID']||'').trim().toLowerCase();
      if(!/^[a-f0-9]{16}$/.test(draftId))draftId=generateDraftId();
      status.textContent='Verifica di sicurezza…';
      var token=await getTurnstileToken(row);
      status.textContent='Caricamento privato in corso…';
      var upload=await fetch('https://larflaser-foto-api.larflaser.workers.dev/upload',{
        method:'POST',mode:'cors',cache:'no-store',
        headers:{'Content-Type':file.type,'X-File-Kind':kind,
          'X-Original-Filename':encodeURIComponent(file.name),
          'X-Larflaser-Draft-ID':draftId,'X-Turnstile-Token':token},body:file
      });
      var uploadData=await upload.json();
      if(!upload.ok||!uploadData.success||!uploadData.photo_id)throw new Error('Caricamento fallito: '+(uploadData.error||upload.status));
      var newId=String(uploadData.photo_id);
      if(!/^[a-z0-9_-]{6,150}$/i.test(newId))throw new Error('Risposta del caricamento non valida.');
      // Salva prima la nuova miniatura nel browser. L'originale resta privato su R2.
      status.textContent='Aggiornamento dell’articolo nel carrello…';
      await store(newId,file,kind);
      var latest=await cartJSON();
      var matching=freshLineItem(latest,oldKey,kind,oldId);
      var properties=Object.assign({}, matching.item.properties||{});
      properties[propKey]=newId;
      properties['_Larflaser Draft ID']=draftId;
      var drawer=document.querySelector('cart-drawer');
      var requestedSections=(drawer&&typeof drawer.getSectionsToRender==='function')
        ?drawer.getSectionsToRender().map(function(s){return s.id;}):['cart-drawer','cart-icon-bubble'];
      if(requestedSections.indexOf('cart-drawer')===-1)requestedSections.push('cart-drawer');
      var changed=await fetch(getCartURL('change'),{
        method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:matching.item.key,properties:properties,
          sections:requestedSections,sections_url:location.pathname})
      });
      var result=await changed.json();
      if(!changed.ok||!Array.isArray(result.items))throw new Error(result.description||'Impossibile modificare il carrello.');
      status.textContent='Immagine sostituita correttamente!';status.dataset.error='false';
      revision++;
      if(drawer&&typeof drawer.renderContents==='function'&&result.sections&&result.sections['cart-drawer']) {
        var newItem=result.items.find(function(item){return String(item.properties?.[propKey]||'')===newId;});
        drawer.renderContents({id:newItem?newItem.key:matching.item.key,sections:result.sections});
        roots().forEach(observe);schedule();
      } else {
        // Craft differenti: aggiorniamo il carrello senza perdere i riferimenti all'ordine.
        window.location.reload();
      }
    }catch(error){
      status.textContent=(error&&error.message?error.message:'Aggiornamento non riuscito.')+' La foto precedente resta collegata all’articolo.';
      status.dataset.error='true';
      changeButton.disabled=false;
    }
  }
  async function makeRow(kind,id,key) {
    var entry=await read(id);
    var title=kind==='qr' ? 'QR Code' : 'Foto/logo';
    var row=document.createElement('div');
    row.className='larf-cart-files__row '+(kind==='qr'?'larf-cart-files__row--qr':'larf-cart-files__row--photo');
    var thumb;
    if(entry){
      thumb=document.createElement('button');thumb.type='button';thumb.className='larf-cart-files__thumb';
      thumb.setAttribute('aria-label','Ingrandisci '+title+' senza aprire un\'altra scheda');
      var img=document.createElement('img');img.src=entry.src;img.className='larf-cart-files__image';
      img.alt='Miniatura '+title;img.width=52;img.height=52;thumb.appendChild(img);
      thumb.addEventListener('click',function(){openModal(entry.src,title,thumb,kind);});
    }else{
      thumb=document.createElement('span');thumb.className='larf-cart-files__thumb larf-cart-files__placeholder';
      thumb.textContent='▧';thumb.setAttribute('aria-hidden','true');
    }
    row.appendChild(thumb);
    var info=document.createElement('div');info.className='larf-cart-files__info';
    var heading=document.createElement('strong');
    heading.className='larf-cart-files__title '+(kind==='qr'?'larf-cart-files__title--qr':'larf-cart-files__title--photo');
    heading.textContent=title;info.appendChild(heading);
    if(entry&&entry.name){
      var filename=document.createElement('span');filename.className='larf-cart-files__name';
      filename.textContent=entry.name;filename.title=entry.name;info.appendChild(filename);
    }
    if(!entry){
      var missing=document.createElement('span');missing.className='larf-cart-files__missing';
      missing.textContent='Miniatura non disponibile in questo browser. Il file originale è privato su Larflaser.';
      info.appendChild(missing);
    }
    row.appendChild(info);
    var actions=document.createElement('div');actions.className='larf-cart-files__actions';
    var change=document.createElement('button');change.type='button';change.className='larf-cart-files__change';
    change.textContent=kind==='qr'?'Cambia QR':'Cambia foto';
    var picker=document.createElement('input');picker.type='file';picker.className='larf-cart-files__picker';
    picker.accept='image/png,image/jpeg,image/webp';
    picker.setAttribute('aria-label',kind==='qr'?'Scegli nuovo QR Code':'Scegli nuova foto o logo');
    var status=document.createElement('span');status.className='larf-cart-files__status';
    status.setAttribute('role','status');status.setAttribute('aria-live','polite');
    change.addEventListener('click',function(){picker.click();});
    picker.addEventListener('change',function(){var file=picker.files&&picker.files[0];if(file)void changeImageInCart(file,kind,id,String(key),row,change,status);picker.value='';});
    actions.appendChild(change);actions.appendChild(status);actions.appendChild(picker);
    row.appendChild(actions);
    return row;
  }
  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled=setTimeout(function() {scheduled=0;void render();},180);
  }
  function roots() {
    return Array.from(document.querySelectorAll('cart-drawer, #CartDrawer, #main-cart-items, cart-items'))
      .filter(function(el,i,all){return !all.some(function(other){return other!==el && other.contains(el);});});
  }
  function classifyExistingOptions(dl) {
    Array.from(dl.querySelectorAll(':scope > .product-option')).forEach(function(option) {
      var term=option.querySelector('dt');
      var label=String(term ? term.textContent : '').toLowerCase().trim();
      option.classList.remove('larf-cart-opt--font','larf-cart-opt--whatsapp','larf-cart-opt--notes');
      if (label.indexOf('font preferito')!==-1 || label.indexOf('carattere preferito')!==-1)
        option.classList.add('larf-cart-opt--font');
      else if (label.indexOf('whatsapp')!==-1)
        option.classList.add('larf-cart-opt--whatsapp');
      else if (label.indexOf('note sulla personalizzazione')!==-1)
        option.classList.add('larf-cart-opt--notes');
    });
  }
  async function render() {
    if (running) {schedule();return;}
    var cartRoots=roots(); if (!cartRoots.length) return;
    running=true;
    var observedRevision=revision;
    try {
      var response=await fetch((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root||'/')+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if (!response.ok) return;
      var cart=await response.json();
      if (!cart||!Array.isArray(cart.items)) return;
      for (var r=0;r<cartRoots.length;r++) {
        var root=cartRoots[r];
        for (var i=0;i<cart.items.length;i++) {
          var item=cart.items[i];
          var props=item.properties||{};
          var idPhoto=props['_Larflaser Photo ID'];
          var idQR=props['_Larflaser QR ID'];
          var rowId=root.matches('cart-drawer, #CartDrawer')?'CartDrawer-Item-'+(i+1):'CartItem-'+(i+1);
          var itemRow=root.querySelector('[id="'+rowId+'"]')||root.querySelectorAll('.cart-item')[i];
          if (!itemRow) continue;
          var host=itemRow.querySelector('.cart-item__details')||itemRow.querySelector('.cart-item__name')?.parentElement;
          if (!host) continue;
          var dl=host.querySelector('dl');
          if (!dl) { dl=document.createElement('dl'); host.appendChild(dl); }
          dl.classList.add('larf-cart-props-v15');
          classifyExistingOptions(dl);
          // Togli solo i riquadri delle versioni vecchie, senza alterare altri dettagli.
          Array.from(host.querySelectorAll('.larf-cart-files')).forEach(function(el){el.remove();});
          if (!idPhoto && !idQR) {
            Array.from(dl.querySelectorAll(':scope > .larf-cart-files__row')).forEach(function(el){el.remove();});
            delete dl.dataset.larfSignature;
            continue;
          }
          var signature=String(item.key||'')+'|'+String(idPhoto||'')+'|'+String(idQR||'');
          var existing=Array.from(dl.querySelectorAll(':scope > .larf-cart-files__row'));
          if (dl.dataset.larfSignature===signature && dl.dataset.larfRevision===String(observedRevision) &&
              existing.length===Number(Boolean(idPhoto))+Number(Boolean(idQR))) continue;
          var pendingRows=[];
          if (idPhoto) pendingRows.push(await makeRow('photo',String(idPhoto),String(item.key||'')));
          if (idQR) pendingRows.push(await makeRow('qr',String(idQR),String(item.key||'')));
          if (!host.isConnected || !dl.isConnected) continue;
          Array.from(dl.querySelectorAll(':scope > .larf-cart-files__row')).forEach(function(el){el.remove();});
          pendingRows.forEach(function(row){dl.appendChild(row);});
          dl.dataset.larfSignature=signature;
          dl.dataset.larfRevision=String(observedRevision);
        }
      }
    } catch(e) { console.warn('Larflaser: anteprime carrello non disponibili',e); }
    finally {running=false;if (revision!==observedRevision) schedule();}
  }
  function observe(root) {
    if(root.dataset.larfCartObserved==='true')return;
    root.dataset.larfCartObserved='true';
    var ob=new MutationObserver(function(records) {
      var relevant=records.some(function(record) {
        if(record.target.closest?.('.larf-cart-files'))return false;
        var nodes=Array.from(record.addedNodes).concat(Array.from(record.removedNodes));
        return nodes.some(function(node){return node.nodeType===1&&!node.classList.contains('larf-cart-files');});
      });
      if(relevant)schedule();
    });
    ob.observe(root,{childList:true,subtree:true});
  }
  function start() {
    roots().forEach(observe);schedule();
    document.addEventListener('shopify:cart:lines-update',schedule);
    document.addEventListener('cart:updated',schedule);
    document.addEventListener('cart:refresh',schedule);
    window.addEventListener('larflaser:preview-updated',function() {revision++;schedule();});
    document.addEventListener('click',function(e) {
      if(e.target.closest('button[name="add"], .header__icon--cart, cart-drawer'))
        setTimeout(function(){roots().forEach(observe);schedule();},500);
    },true);
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
